import type { Dispatch } from 'redux';
import { useDispatch } from 'react-redux';
import { useCallback } from 'react';

import { ITableRenderCell } from 'CorePackage/TableModule/interfaces/ITableRenderCell';
import { formatBytes } from 'CorePackage/MainModule/common/formatBytes';
import { RootActions } from 'CorePackage/MainModule/types/RootActions';

import { IExportRow } from '../interfaces/IExportRow';
import { exportDownloadFile } from '../actions/exportActions';

export function ExportTableFileNameCell({ row }: ITableRenderCell<IExportRow>) {
  const dispatch = useDispatch<Dispatch<RootActions>>();

  const handleFileLinkClick = useCallback(() => {
    dispatch(exportDownloadFile(row.id, row.filename));
  }, [dispatch, row.filename, row.id]);

  return (
    <>
      <span className="shared-table-link" onClick={handleFileLinkClick}>
        {row.filename || undefined}
      </span>
      {row.filename && `(${formatBytes(row.fileSize)})`}
    </>
  );
}
